export default __webpack_public_path__ + "static/media/27.e2a60d71.png";